module.exports = __webpack_public_path__ + "img/inncash-background-club.352f48a6.webp";